import { Checkbox, SelectInput } from "@project/shared"
import {
  SheetData,
  SheetsDispatcher,
  CautionDispatcher,
} from "../../../../types"
import { addCommas } from "../../../../utils/commaSeparator"
import {
  handleInformationCreationCategory,
  handleSelectSheet,
} from "../../handler"
import { t } from "i18next"
import { DIVISION_ITEMS } from "../../constant"

export function buildColumns(
  sheets: SheetData,
  setSheets: SheetsDispatcher,
  facilityLength: number,
  setCaution: CautionDispatcher
) {
  return [
    {
      title: t("Selection"),
      key: "selection",
      dataIndex: "receipt_upper_limit_management_id",
      width: 79,
      className: "no-print",
      render: (id) => (
        <Checkbox
          className={"selection-checkbox"}
          checked={sheets[id]?.checked ?? false}
          onChange={() => handleSelectSheet(id, sheets, setSheets)}
        />
      ),
      onCell: (_, index) => ({ rowSpan: index === 0 ? facilityLength : 0 }),
    },
    {
      title: t("Division"),
      key: "division",
      dataIndex: "receipt_upper_limit_management_id",
      width: 143,
      className: "division-head-cell head-cell",
      render: (id) => {
        return (
          <SelectInput
            options={DIVISION_ITEMS}
            value={
              sheets[id]?.receiptUpperLimitManagement
                ?.information_creation_category ?? 1
            }
            onChange={(val) => {
              handleInformationCreationCategory(val, id, sheets, setSheets)
              setCaution(
                t("*Division has changed. Please click save to reflect on CSV.")
              )
            }}
          />
        )
      },
      onCell: (_, index) => ({ rowSpan: index === 0 ? facilityLength : 0 }),
    },
    {
      title: t("Item"),
      key: "line_no",
      dataIndex: "line_no",
      width: 65,
      className: "item-head-cell head-cell",
    },
    {
      title: t("Business number"),
      dataIndex: "facility_number",
      key: "businessNumber",
      width: 144,
      className: "business-number-head-cell head-cell",
    },

    {
      title: t("Name of business"),
      dataIndex: "facility_name",
      key: "nameOfBusiness",
      className: "name-of-business-head-cell head-cell",
    },

    {
      title: t("Total cost"),
      dataIndex: "total_amount",
      key: "totalCost",
      width: 144,
      className: "total-cost-head-cell head-cell",
      render: (data) => addCommas(data) + "円",
    },

    {
      title: t("User burden"),
      dataIndex: "burden_amount",
      key: "userBurden",
      width: 144,
      className: "user-burden-head-cell head-cell",
      render: (data) => addCommas(data) + "円",
    },

    {
      title: t("After control result user burden"),
      dataIndex: "management_result_burden_amount",
      key: "afterCtrlResultUserBurden",
      width: 144,
      className: "after-ctrl-result-user-burden-head-cell head-cell",
      render: (data) => addCommas(data) + "円",
    },
  ]
}
